import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { updateLocations } from 'app/state/locations/locations.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';

@Injectable({
    providedIn: 'root',
})
export class LocationsEffects {
    syncWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterdata) => updateLocations({ locations: masterdata?.locations ?? [] })),
        ),
    );
    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
